import { Box, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import { routes } from "../../../../app/paths";
import { AssignedTalent } from "../../orderAPI";
import { PropsWithChildren } from "react";
import InfoTooltip from "../../../../common/components/functional/InfoTooltip/InfoTooltip";
import { FlexVerticalAligned } from "../../../../common/components/styled/styled";
import NewIcon from "@mui/icons-material/NewReleases";
import { useTranslation } from "react-i18next";

type Props = {
  talent: AssignedTalent;
};

const ShiftTalentInfoLink = ({
  talent,
  children,
}: PropsWithChildren<Props>) => {
  const theme = useTheme();
  const { t } = useTranslation("order");

  return (
    <Box display="flex" alignItems="center" gap="8px" minHeight="40px">
      <Typography variant="secondary" sx={{ whiteSpace: "nowrap" }}>
        <FlexVerticalAligned gap="4px">
          <Link
            to={routes.talentProfile(talent.id)}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              textDecoration: "none",
              color: theme.palette.primary.main,
              display: "inline",
            }}
          >
            {talent.name}
          </Link>
          {!!talent.isNewWorkerForCustomer && (
            <InfoTooltip
              title={t("newWorkerForCustomerInfo")}
              variant="primary"
              icon={<NewIcon />}
            />
          )}
        </FlexVerticalAligned>
      </Typography>
      {children}
    </Box>
  );
};

export default ShiftTalentInfoLink;
